import { render, staticRenderFns } from "./BradfordCity.vue?vue&type=template&id=f311760c&scoped=true&"
import script from "./BradfordCity.vue?vue&type=script&lang=js&"
export * from "./BradfordCity.vue?vue&type=script&lang=js&"
import style0 from "./BradfordCity.vue?vue&type=style&index=0&id=f311760c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f311760c",
  null
  
)

export default component.exports